import React, {useRef, useState, useEffect} from 'react';

// Importar iconos
import iconoCertificado from '../assets/certificaciones/Certificado.png';
import imgIso from '../assets/certificaciones/Iso22000.png';
import imgDisney from '../assets/certificaciones/Disney.png';
import imgNBC from '../assets/certificaciones/NBCUniversal.png';
//import imgCertificado from '../assets/certificaciones/Certificado.png';

//Contenido de los certificados
const certificaciones = [
  {
    id: 1,
    nombre: 'ISO 22000:2018',
    hrefname: 'iso-22000',
    nombredescripcion:'ISO 22000:2018',
    iconobtn: iconoCertificado,
    txt1descripcion:['Contar con esta certificación internacional es nuestra forma de garantizarte que cada una de nuestras etiquetas cumplen con los más altos estándares globales de inocuidad y seguridad alimentaria. '],
    txt2descripcion:'Trabajamos bajo esta certificación porque entendemos que, para que tu producto sea competitivo y confiable, debe llegar impecable: desde el contenido y el empaque, hasta el consumidor final.',
    txt3descripcion:'',
    imgcertified: imgIso,

  },
  {
    id: 2,
    nombre: 'Disney International Programs',
    hrefname: 'disney-international-programs',
    nombredescripcion:'Disney International Programs',
    iconobtn: iconoCertificado,
    txt1descripcion:['Estamos autorizados por Disney para imprimir sus personajes e íconos, cumpliendo con sus estrictos estándares de calidad, ética y responsabilidad laboral.'],
    txt2descripcion:'Contar con la certificación ILS y la autorización FAMA garantiza que producimos solo con licencias oficiales, asegurando trazabilidad, seguridad, confianza y durabilidad en cada etiqueta.',
    txt3descripcion:'Así, tus productos con licencia Disney, Marvel u otras marcas globales llegan al mercado con la calidad que tu marca y aliados merecen.',
    imgcertified: imgDisney,
  },
  {
    id: 3,
    nombre: 'NBC Universal Vendor Compliance',
    hrefname: 'nbc-universal-vendor-compliance',
    nombredescripcion:'NBC Universal Vendor Compliance',
    iconobtn: iconoCertificado,
    txt1descripcion:['El cumplimiento normativo de proveedores de NBC Universal asegura que todos los proveedores externos, contratistas y socios comerciales operemos bajo las mismas reglas de calidad, legalidad y responsabilidad establecidos por NBCU.'],
    txt2descripcion:'Esto incluye desde derechos humanos y condiciones laborales, hasta salud, seguridad y regulaciones específicas.',
    txt3descripcion:'Cumplir con el Vendor Compliance de NBCUniversal es la manera de demostrar que compartimos su visión de excelencia y el compromiso con un trabajo responsable, seguro y a la altura de cada uno de los clientes que confían en nosotros.',
    imgcertified: imgNBC,
  },
];

const Certificaciones = () => {
  // Creamos un contenedor de refs
  const sectionRefs = useRef([]);
  const btnsContainerRefCert = useRef(null);
   
  const [hoveredIdx, setHoveredIdx] = useState(null);
    const [activeIdx, setActiveIdx] = useState(0); //  inicia en 0 (primer botón activo)
    //Fue clickeado?
    const [buttonClicked, setButtonClicked] = useState(false);
    //Hay Scroll
    const [scrolled, setScrolled] = useState(false);
    //¿Que evento ocurrio?
    const [eventsOrder, setEventsOrder] = useState(null);
    // El primer botón está activo
    useEffect(() => {
      // Activar el scrollspy manualmente en React
      const bootstrapScrollSpyCert = new window.bootstrap.ScrollSpy(document.getElementById('scrollspy-containercertificaciones'), {
        target: '#certificacionessection',
        smoothScroll: true,
      });
  
      return () => {
        bootstrapScrollSpyCert.dispose(); // Limpiar el scrollspy cuando el componente se desmonta
      };
    }, []);
    //setActiveIdx(null);
    const buttonActive = (idx) => {
      //setTimeout(() => {
        //setActiveIdx(idx);
        if(activeIdx === idx || hoveredIdx === idx){
          return 'active';
        }else{
          return '';
        }
      //}, 50);
      
    };

  // Scroll manual por click
  const scrollToSection = (idx) => {
    setActiveIdx(idx);
    if (sectionRefs.current[idx]) {
      sectionRefs.current[idx].scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (btnsContainerRefCert.current && window.innerWidth >= 768) {
        
        const btnCert = btnsContainerRefCert.current.querySelectorAll('button')[idx];
        if (btnCert) {
          btnCert.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
      }
      
    }
    
  };

  const handleScroll = () => {
    const offsets = sectionRefs.current.map(ref => {
      if (!ref) return Number.POSITIVE_INFINITY;
        const rect = ref.getBoundingClientRect();
      return Math.abs(rect.top - 120); // 120 es el scrollMarginTop  
    });
    const minOffset = Math.min(...offsets);
    const idx = offsets.indexOf(minOffset);
    if (idx !== -1 && idx !== activeIdx) {
      setActiveIdx(idx);
    }
  };
 
  window.addEventListener('scroll', handleScroll, { passive: true });
  //return () => window.removeEventListener('scroll', handleScroll);

  // Scroll automático por scroll del usuario
  /*useEffect(() => {
  const handleScroll = () => {
    const offsets = sectionRefs.current.map(ref => {
      if (!ref) return Number.POSITIVE_INFINITY;
      const rect = ref.getBoundingClientRect();
      return Math.abs(rect.top - 120); // 120 es el scrollMarginTop
    });
    const minOffset = Math.min(...offsets);
    const idx = offsets.indexOf(minOffset);
    if (idx !== -1 && idx !== activeIdx) {
      setActiveIdx(idx);
    }
  };

  window.addEventListener('scroll', handleScroll, { passive: true });
  return () => window.removeEventListener('scroll', handleScroll);
    // eslint-disable-next-line
  }, [activeIdx]);*/

  return (
    <div className="main-content">
      <div className="container-fluid p-0">
        <div className="page-container pt-0 pb-0">
          {/* Frase de Certificaciones */}
          <div className='container-fluid pdg-section-ch pb-md-0'>
            <div className="row align-items-center mb-5 mt-3">
              <div className="col-12 text-start p-0">
                <h1 className="display-4  lightblack mb-3 tit-principal" style={{width:'70%'}}>
                  <span style={{ color: 'var(--color-principal)'}}>En Mega Label somos
                  </span> etiquetas que hacen más:
                </h1>   
                <p  className="lightblack" style={{fontWeight:'500', fontSize:'1.5rem'}}>Te respaldamos con la confianza que brindan las mejores certificaciones.</p>                     
              </div>
            </div>
          </div>

          {/* Certificaciones */}
            <div className='container-fluid pdg-section-scroll' style={{ background: 'black'}}>
              <div className="row align-items-start mb-5">
                {/* Botones verticales */}
                <div className="col-12 col-md-4 mb-4 mb-md-0 p-0 d-md-block d-none sticky-industrias">
                  <div className='sticky-industrias' style={{position: 'relative'}}>
                    {/*ref={btnsContainerRefCert} */}
                    <div id='certificacionessection' className="d-flex flex-column gap-3" >
                      {/**key={certificado.id}
                       * 
                       */}
                      {certificaciones.map((certificado, idx) => (
                        <a
                          key={certificado.id}
                          className={`btn btn-custom btn-wscroll d-flex align-items-center ${buttonActive(idx)}`}
                          aria-label={`Ir a sección ${certificado.nombre}`}
                          onClick={() => scrollToSection(idx)}
                        >
                          <img
                            src={
                              activeIdx === idx || hoveredIdx === idx
                              ? certificado.iconobtn
                              : certificado.iconobtn
                            }
                            alt={certificado.nombre}
                            style={{
                              width: '30px',
                              marginRight: '1%'
                            }}
                          />
                          <span className="btn-txtscroll text-start">{certificado.nombre}</span>
                        </a>
                      ))}
                    </div>
                  </div>
                </div>
                  {/* Contenido de cada certificado */}
                  <div className="col-12 col-md-8 p-0">
                    <div id="scrollspy-containercertificaciones" className="scrollspy-example-2" tabIndex="0">
                      {/*
                        key={certificacion.id}
                      
                      */}
                      {certificaciones.map((certificacion, idx) => (
                        <div
                          key={certificacion.id}
                          ref={el => sectionRefs.current[idx] = el}
                          id={certificacion.hrefname}
                          className="pb-4 container-fluid certificado"
                          style={{
                            scrollMarginTop: '120px',
                            marginBottom: idx === certificaciones.length - 1 ? '0' : '23.5%'
                          }}
                        >
                          <div className='row'>
                            <div className='col-lg-2 col-md-12 p-0'>
                              <img className='img-cert' 
                                src={certificacion.imgcertified} 
                                alt={certificacion.nombre}
                              />
                            </div>
                            <div className="col-lg-10 col-md-12 p-0">
                              <h2 className="" style={{ color: 'var(--color-texto-blanco)', fontWeight:'700', marginBottom:'2.7%' }}>{certificacion.nombredescripcion}</h2>
                              <p style={{ color: '#fff', margin:'0', textTransform:'uppercase' }}>{certificacion.descripcion}</p>
                              <p style={{ color: '#fff' }}>{certificacion.txt1descripcion}</p>
                              <p style={{ color: '#fff' }}>{certificacion.txt2descripcion}</p>
                              <p style={{ color: '#fff' }}>{certificacion.txt3descripcion}</p>
                          </div>          
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div> 
        </div>
      </div>
    </div>
  );
};

export default Certificaciones; 